import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DataFieldPropertyType } from '../data-field-property-type';
import { DataFieldType } from '../data-field-type';
import { FiDataFieldView_DataField, FiDataFieldView_DataFieldObject } from './data-field-view-base';
import { FiDataFieldViewNameComponent } from './name/name.component';
import { BusinessUnitViewDataFieldViewModel } from './data-field-view-model';
import { FiDataFieldViewCustomComponent } from './custom/custom.component';
import { FiDataFieldViewDescriptionComponent } from './description/description.component';
import { FiDataFieldViewClusterComponent } from './cluster/cluster.component';
import { FiDataFieldViewAreasComponent } from './areas/areas.component';
import { FiDataFieldViewBusinessAreasComponent } from './business-areas/business-areas.component';
import { FiDataFieldViewPhoneNumberComponent } from './phone-number/phone-number.component';
import { FiDataFieldViewEmailAddressComponent } from './email-address/email-address.component';
import { FiDataFieldViewAddressComponent } from './address/address.component';
import { FiDataFieldViewCustomCalendarComponent } from './custom-calendar/custom-calendar.component';
import { FiDataFieldViewCustomPreSetOptionsComponent } from './custom-pre-set-options/custom-pre-set-options.component';
import { FiDataFieldViewActiveComponent } from './active/active.component';
import { FiDataFieldViewRolesComponent } from './roles/roles.component';
import { FiDataFieldViewTagsComponent } from './tags/tags.component';
import { FiDataFieldViewUnitsComponent } from './units/units.component';
import { FiDataFieldViewOrgNrComponent } from '@fi-app/data-field/data-field-view/org-nr/org-nr.component';

@Component({
    selector: 'data-field-view',
    template: '<ng-container *ngComponentOutlet="getComponentType()"></ng-container>',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./data-field-view.component.scss'],
    providers: [
        {
            provide: FiDataFieldView_DataField,
            useFactory: (instance: FiDataFieldViewComponent) => instance.dataField,
            deps: [FiDataFieldViewComponent],
        },
        {
            provide: FiDataFieldView_DataFieldObject,
            useFactory: (instance: FiDataFieldViewComponent) => instance.dataFieldObject,
            deps: [FiDataFieldViewComponent],
        },
    ],
    standalone: false,
})
export class FiDataFieldViewComponent {
    @Input() dataField: BusinessUnitViewDataFieldViewModel;
    @Input() dataFieldObject: any;

    public getComponentType() {
        switch (this.dataField.PropertyType) {
            case DataFieldPropertyType.Name:
                return FiDataFieldViewNameComponent;
            case DataFieldPropertyType.Description:
                return FiDataFieldViewDescriptionComponent;
            case DataFieldPropertyType.Cluster:
                return FiDataFieldViewClusterComponent;
            case DataFieldPropertyType.Areas:
                return FiDataFieldViewAreasComponent;
            case DataFieldPropertyType.BusinessAreas:
                return FiDataFieldViewBusinessAreasComponent;
            case DataFieldPropertyType.PhoneNumber:
                return FiDataFieldViewPhoneNumberComponent;
            case DataFieldPropertyType.EmailAddress:
                return FiDataFieldViewEmailAddressComponent;
            case DataFieldPropertyType.Address:
                return FiDataFieldViewAddressComponent;
            case DataFieldPropertyType.Password:
                return;
            case DataFieldPropertyType.Active:
                return FiDataFieldViewActiveComponent;
            case DataFieldPropertyType.Roles:
                return FiDataFieldViewRolesComponent;
            case DataFieldPropertyType.Tags:
                return FiDataFieldViewTagsComponent;
            case DataFieldPropertyType.Units:
                return FiDataFieldViewUnitsComponent;
            case DataFieldPropertyType.Languages:
                return;
            case DataFieldPropertyType.PKOrgNr:
                return FiDataFieldViewOrgNrComponent;

            case DataFieldPropertyType.Custom: {
                switch (this.dataField.Type) {
                    case DataFieldType.Calendar:
                        return FiDataFieldViewCustomCalendarComponent;
                    case DataFieldType.PreSetOptions:
                        return FiDataFieldViewCustomPreSetOptionsComponent;
                }
                return FiDataFieldViewCustomComponent;
            }
            default:
                throw `FI: BusinessUnitViewDataFieldViewComponent::getComponentType() unknown PropertyType ${this.dataField.PropertyType}`;
        }
    }
}
